import Svg from '@doordash/component-svg'
import * as React from 'react'

type Props = {
  width?: number
  height?: number
}

export const CvcCard: React.FC<Props> = ({ width = 295, height = 217 }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 295 217"
  >
    <rect width="200" height="122" fill="#F8F8F8" rx="12" />
    <path fill="#4D4D4D" d="M0 20H200V42H0z" />
    <path fill="#fff" d="M14 52H186V76H14z" />
    <rect
      width="126"
      height="5"
      x="14"
      y="85"
      fill="#4D4D4D"
      opacity="0.1"
      rx="2.5"
    />
    <rect
      width="80"
      height="5"
      x="67"
      y="61"
      fill="#4D4D4D"
      opacity="0.1"
      rx="2.5"
    />
    <rect
      width="92"
      height="5"
      x="74"
      y="95"
      fill="#4D4D4D"
      opacity="0.1"
      rx="2.5"
    />
    <rect
      width="55"
      height="5"
      x="74"
      y="106"
      fill="#4D4D4D"
      opacity="0.1"
      rx="2.5"
    />
    <rect
      width="29"
      height="29"
      x="154.5"
      y="49.5"
      fill="#fff"
      fillOpacity="0.5"
      stroke="#B71000"
      rx="14.5"
    />
    <path
      fill="#191919"
      d="M162.093 59.6c-.3.6-.72 1.02-1.8 1.14v.9h1.5V68h1.32v-8.4h-1.02zm8.397 8.4v-1.2h-4.08c1.02-1.92 4.08-2.28 4.08-4.74 0-1.44-1.14-2.58-2.82-2.58-2.22 0-2.7 1.92-2.7 1.92l1.08.48s.36-1.2 1.62-1.2c.96 0 1.5.54 1.5 1.38 0 2.22-4.26 2.1-4.26 5.94h5.58zm6.785 0v-1.2h-4.08c1.02-1.92 4.08-2.28 4.08-4.74 0-1.44-1.14-2.58-2.82-2.58-2.22 0-2.7 1.92-2.7 1.92l1.08.48s.36-1.2 1.62-1.2c.96 0 1.5.54 1.5 1.38 0 2.22-4.26 2.1-4.26 5.94h5.58z"
    />
    <path
      fill="#B71000"
      d="M212.25 59.48c-2.52 0-4.44 1.92-4.44 4.32 0 2.4 1.92 4.32 4.44 4.32 2.28 0 3.48-1.68 3.48-1.68l-.84-.84s-.9 1.32-2.64 1.32c-1.74 0-3.12-1.38-3.12-3.12 0-1.74 1.38-3.12 3.12-3.12 1.74 0 2.58 1.26 2.58 1.26l.84-.84s-1.14-1.62-3.42-1.62zm7.617 8.52h1.32l3.3-8.4h-1.38l-2.58 6.72-2.58-6.72h-1.38l3.3 8.4zm8.637 0h1.32l3.3-8.4h-1.38l-2.58 6.72-2.58-6.72h-1.38l3.3 8.4zm10.016-8.52h-1.08l-3.6 11.04h1.08l3.6-11.04zm5.523 0c-2.52 0-4.44 1.92-4.44 4.32 0 2.4 1.92 4.32 4.44 4.32 2.28 0 3.48-1.68 3.48-1.68l-.84-.84s-.9 1.32-2.64 1.32c-1.74 0-3.12-1.38-3.12-3.12 0-1.74 1.38-3.12 3.12-3.12 1.74 0 2.58 1.26 2.58 1.26l.84-.84s-1.14-1.62-3.42-1.62zM251.66 68h1.32l3.3-8.4h-1.38l-2.58 6.72-2.58-6.72h-1.38l3.3 8.4zm9.656-8.52c-2.52 0-4.44 1.92-4.44 4.32 0 2.4 1.92 4.32 4.44 4.32 2.28 0 3.48-1.68 3.48-1.68l-.84-.84s-.9 1.32-2.64 1.32c-1.74 0-3.12-1.38-3.12-3.12 0-1.74 1.38-3.12 3.12-3.12 1.74 0 2.58 1.26 2.58 1.26l.84-.84s-1.14-1.62-3.42-1.62zm6.78 5.64c0 1.62 1.38 3 3 3 1.5 0 2.4-1.2 2.4-1.2l-.78-.78s-.6.9-1.62.9c-.96 0-1.8-.84-1.8-1.92s.84-1.92 1.8-1.92c1.02 0 1.56.84 1.56.84l.78-.78s-.84-1.14-2.34-1.14c-1.62 0-3 1.38-3 3zm11.034 0c0 1.08-.84 1.92-1.8 1.92-.96 0-1.8-.84-1.8-1.92s.84-1.92 1.8-1.92c.96 0 1.8.84 1.8 1.92zm-4.8 0c0 1.62 1.38 3 3 3s3-1.38 3-3-1.38-3-3-3-3 1.38-3 3zm9.781-3c-1.5 0-2.82 1.32-2.82 3s1.32 3 2.82 3c1.14 0 1.86-.78 1.86-.78V68h1.2v-8.4h-1.2v3.3s-.72-.78-1.86-.78zm.12 4.92c-.9 0-1.74-.84-1.74-1.92s.84-1.92 1.74-1.92 1.74.84 1.74 1.92-.84 1.92-1.74 1.92zm10.084-1.5s.06-.24.06-.6c0-1.62-1.2-2.82-2.82-2.82-1.62 0-2.94 1.32-2.94 2.94 0 1.68 1.38 3.06 3 3.06s2.52-1.2 2.52-1.2l-.78-.78s-.6.9-1.74.9c-.96 0-1.68-.72-1.8-1.5h4.5zm-2.76-2.4c.9 0 1.5.6 1.644 1.38h-3.336c.192-.78.792-1.38 1.692-1.38z"
    />
    <rect width="200" height="122" x="95" y="95" fill="#D1F0F6" rx="12" />
    <path
      fill="#BEDFE9"
      d="M103 104a3 3 0 013-3v105a3 3 0 01-3-3v-99zM285 104a3 3 0 00-3-3v105a3 3 0 003-3v-99z"
    />
    <path fill="#BEDFE9" d="M282 101a3 3 0 013 3H103a3 3 0 013-3h176z" />
    <path
      fill="#E1F6FA"
      stroke="#BEDFE9"
      d="M217.963 156.5c0 8.126-2.722 15.38-6.984 20.545-4.26 5.161-9.936 8.122-15.979 8.122-6.043 0-11.719-2.961-15.979-8.122-4.262-5.165-6.984-12.419-6.984-20.545 0-8.126 2.722-15.38 6.984-20.545 4.26-5.161 9.936-8.122 15.979-8.122 6.043 0 11.719 2.961 15.979 8.122 4.262 5.165 6.984 12.419 6.984 20.545zM195 188.5c14.721 0 26.5-14.421 26.5-32s-11.779-32-26.5-32-26.5 14.421-26.5 32 11.779 32 26.5 32z"
    />
    <rect
      width="29"
      height="29"
      x="249.5"
      y="129.5"
      fill="#E7F5FA"
      stroke="#B71000"
      rx="14.5"
    />
    <path
      fill="#191919"
      d="M257.093 139.6c-.3.6-.72 1.02-1.8 1.14v.9h1.5V148h1.32v-8.4h-1.02zm8.397 8.4v-1.2h-4.08c1.02-1.92 4.08-2.28 4.08-4.74 0-1.44-1.14-2.58-2.82-2.58-2.22 0-2.7 1.92-2.7 1.92l1.08.48s.36-1.2 1.62-1.2c.96 0 1.5.54 1.5 1.38 0 2.22-4.26 2.1-4.26 5.94h5.58zm6.785 0v-1.2h-4.08c1.02-1.92 4.08-2.28 4.08-4.74 0-1.44-1.14-2.58-2.82-2.58-2.22 0-2.7 1.92-2.7 1.92l1.08.48s.36-1.2 1.62-1.2c.96 0 1.5.54 1.5 1.38 0 2.22-4.26 2.1-4.26 5.94h5.58z"
    />
    <rect width="45" height="5" x="229" y="161" fill="#BEDFE9" rx="2.5" />
    <rect width="27" height="5" x="115" y="161" fill="#BEDFE9" rx="2.5" />
    <rect width="19" height="5" x="255" y="171" fill="#BEDFE9" rx="2.5" />
    <rect width="45" height="5" x="115" y="171" fill="#BEDFE9" rx="2.5" />
    <rect width="98" height="5" x="115" y="201" fill="#BEDFE9" rx="2.5" />
    <rect width="55" height="5" x="219" y="201" fill="#BEDFE9" rx="2.5" />
    <path stroke="#B71000" strokeLinecap="round" d="M264 74v48M204 64h-15" />
    <path
      fill="#0742A6"
      fillRule="evenodd"
      d="M14 101.4c0-2.24 0-3.36.436-4.216a4 4 0 011.748-1.748C17.04 95 18.16 95 20.4 95h7.2c2.24 0 3.36 0 4.216.436a4 4 0 011.748 1.748C34 98.04 34 99.16 34 101.4v3.2c0 2.24 0 3.36-.436 4.216a3.996 3.996 0 01-1.748 1.748C30.96 111 29.84 111 27.6 111h-7.2c-2.24 0-3.36 0-4.216-.436a3.996 3.996 0 01-1.748-1.748C14 107.96 14 106.84 14 104.6v-3.2z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M27.264 100.596a3.379 3.379 0 00-1.196-.213c-1.316 0-2.243.683-2.25 1.661-.01.721.665 1.122 1.17 1.362.515.246.69.406.69.625-.005.337-.416.492-.8.492-.532 0-.818-.08-1.251-.267l-.176-.081-.186 1.127c.313.139.889.262 1.487.268 1.399 0 2.31-.673 2.32-1.715.005-.572-.35-1.01-1.119-1.368-.466-.229-.752-.384-.752-.619.006-.214.242-.433.768-.433a2.32 2.32 0 01.993.192l.12.054.182-1.085zM22.431 105.495h-1.333l.834-5.021h1.333l-.834 5.021z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30.682 100.474H29.65c-.318 0-.56.09-.696.416l-1.98 4.605h1.398l.28-.753h1.712l.159.753h1.234l-1.075-5.021zm-1.646 3.242l.532-1.405.041-.112.135-.369.093.433s.252 1.202.307 1.453h-1.108z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M19.985 100.474l-1.306 3.424-.143-.695-.466-2.308c-.076-.321-.312-.412-.603-.422h-2.145l-.022.101c.523.13.99.318 1.4.551l1.189 4.365h1.41l2.095-5.016h-1.41z"
    />
    <path
      fill="#262626"
      fillRule="evenodd"
      d="M46 101.4c0-2.24 0-3.36.436-4.216a4 4 0 011.748-1.748C49.04 95 50.16 95 52.4 95h7.2c2.24 0 3.36 0 4.216.436a4 4 0 011.748 1.748C66 98.04 66 99.16 66 101.4v3.2c0 2.24 0 3.36-.436 4.216a3.996 3.996 0 01-1.748 1.748C62.96 111 61.84 111 59.6 111h-7.2c-2.24 0-3.36 0-4.216-.436a3.996 3.996 0 01-1.748-1.748C46 107.96 46 106.84 46 104.6v-3.2z"
      clipRule="evenodd"
    />
    <path fill="#FF5F00" d="M53.918 99.643H58.083V106.352H53.918z" />
    <path
      fill="#EB001B"
      fillRule="evenodd"
      d="M54.347 102.998A4.238 4.238 0 0156 99.644a4.37 4.37 0 00-5.852.46 4.223 4.223 0 000 5.789 4.37 4.37 0 005.852.46 4.236 4.236 0 01-1.653-3.355z"
      clipRule="evenodd"
    />
    <path
      fill="#F79E1B"
      fillRule="evenodd"
      d="M63 102.998a4.263 4.263 0 01-2.436 3.838 4.377 4.377 0 01-4.565-.484 4.246 4.246 0 001.654-3.355c0-1.309-.61-2.546-1.654-3.355a4.376 4.376 0 014.565-.483A4.262 4.262 0 0163 102.997v.001z"
      clipRule="evenodd"
    />
    <path
      fill="#016FD0"
      fillRule="evenodd"
      d="M115 142.4c0-2.24 0-3.36.436-4.216a3.991 3.991 0 011.748-1.748c.856-.436 1.976-.436 4.216-.436h7.2c2.24 0 3.36 0 4.216.436a3.991 3.991 0 011.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a3.991 3.991 0 01-1.748 1.748c-.856.436-1.976.436-4.216.436h-7.2c-2.24 0-3.36 0-4.216-.436a3.991 3.991 0 01-1.748-1.748C115 148.96 115 147.84 115 145.6v-3.2z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M116.719 142.148l-.33-.818-.332.818h.662zM124.045 141.309h.671c.161 0 .278.125.278.246 0 .155-.151.246-.269.246h-.68v-.492zM129.831 142.148l-.331-.818-.331.818h.662z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M115 142.4v-.261l.749-1.738h1.296l.426.973v-.973h1.611l.253.703.245-.703h7.232v.354s.38-.354 1.005-.354l2.347.008.418.961v-.969h1.348l.371.552v-.552h1.36v3.122h-1.36l-.356-.554v.554h-1.981l-.199-.492h-.532l-.196.492h-1.344c-.537 0-.881-.347-.881-.347v.347h-2.025l-.402-.492v.492h-7.532l-.199-.492h-.53l-.198.492H115V142.4zm.004.723l1.011-2.338h.766l1.01 2.338h-.673l-.185-.468h-1.085l-.186.468h-.658zm2.856-2.338v2.338h.588v-1.722l.624 1.722h.516l.622-1.722v1.722h.588v-2.338h-.928l-.531 1.511-.544-1.507-.935-.004zm3.34 2.338v-2.338h1.917v.523h-1.323v.4h1.292v.492h-1.292v.415h1.323v.508H121.2zm2.257-2.337v2.337h.588v-.83h.247l.705.83h.718l-.773-.861a.712.712 0 00.644-.718c0-.492-.388-.758-.821-.758h-1.308zm2.969 2.337h-.6v-2.338h.6v2.338zm1.293 0h.129l.247-.511h-.154c-.374 0-.634-.19-.634-.642 0-.382.227-.631.548-.631h.673v-.554h-.649c-.791 0-1.167.494-1.167 1.179 0 .668.38 1.159 1.007 1.159zm.397 0l1.01-2.337h.767l1.01 2.337h-.673l-.186-.468h-1.084l-.186.468h-.658zm2.855-2.338v2.338h.588v-1.507l.978 1.507h.722v-2.338h-.587v1.469l-.954-1.469h-.747z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M125.16 145.405h-.651v.539h.649c.172 0 .292-.114.292-.27 0-.166-.121-.269-.29-.269zM126.889 145.399h.672c.161 0 .278.125.278.246 0 .155-.152.246-.269.246h-.681v-.492z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M134.992 147.174l-.005.227c-.039.025-.336.21-.676.213h-6.679l-.402-.492v.492h-1.318v-.84s-.18.117-.569.117h-.448v.723H122.9l-.356-.473-.361.473h-3.302v-3.122h3.323l.356.462.369-.462H135l-.001.384h-1.129c-.687 0-.922.362-.922.737 0 .42.257.7.719.7h.531c.174 0 .249.099.249.197 0 .103-.075.196-.249.196h-1.176v.508h1.252c.387 0 .624-.187.719-.453l-.001.413zm-15.709-2.298v2.338h1.917v-.508h-1.324v-.415h1.293v-.492h-1.293v-.4h1.324v-.523h-1.917zm11.311 2.338h-1.917v-2.338h1.917v.523h-1.324v.4h1.287v.492h-1.287v.415h1.324v.508zm-8.386-1.154l-.934 1.154h.73l.539-.72.553.72h.74l-.936-1.169.944-1.169h-.712l-.571.732-.569-.732h-.74l.956 1.184zm1.698 1.154v-2.337h1.297c.533 0 .844.341.844.786 0 .537-.397.813-.92.813h-.619v.738h-.602zm3.703-2.338h-1.307v2.338h.588v-.831h.247l.704.831h.718l-.773-.861a.714.714 0 00.645-.718c0-.492-.388-.759-.822-.759zm3.257 2.338v-.508h1.176c.174 0 .249-.093.249-.196 0-.098-.075-.197-.249-.197h-.531c-.462 0-.719-.28-.719-.7 0-.375.235-.737.921-.737h1.144l-.247.526h-.989c-.19 0-.248.099-.248.193 0 .097.072.204.217.204h.556c.515 0 .739.291.739.671 0 .409-.249.744-.767.744h-1.252z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M134.999 144.908l-.233.494h-.989c-.189 0-.248.099-.248.193 0 .097.072.204.217.204h.557c.381 0 .603.16.692.397l.004-1.288z"
    />
  </Svg>
)

export default CvcCard
